import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * /dispatch route entry — smart redirect.
 *   Authenticated (valid session cookie) → /dispatch/dashboard
 *   Not authenticated → /dispatch/login?returnTo=%2Fdispatch%2Fdashboard
 */
const DispatchIndex = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
          credentials: 'include',
        });
        if (cancelled) return;
        if (res.ok) {
          navigate('/dispatch/dashboard', { replace: true });
        } else {
          navigate(
            `/dispatch/login?returnTo=${encodeURIComponent('/dispatch/dashboard')}`,
            { replace: true }
          );
        }
      } catch {
        if (!cancelled) {
          navigate(
            `/dispatch/login?returnTo=${encodeURIComponent('/dispatch/dashboard')}`,
            { replace: true }
          );
        }
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#004C97] flex items-center justify-center">
      <div className="text-white text-center" data-testid="dispatch-index-loading">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#F9A825] mx-auto" />
        <p className="mt-3 text-sm">Loading dispatch…</p>
      </div>
    </div>
  );
};

export default DispatchIndex;
